module.exports = __webpack_public_path__ + "assets/2fd0717b389b1a9d3149b5867a26e076.png";